import React, { useState } from 'react';

const CountryGuides = () => {
  const [selectedCountry, setSelectedCountry] = useState(null);

  const countries = [
    {
      name: 'Thailand',
      code: 'TH',
      requirements: [
        'Proof of onward travel is required for visa-free entry',
        'Ticket must show departure from Thailand within 30 days',
        'Accepted formats: Flight reservation, e-ticket, or booking confirmation',
        'Digital copies on mobile devices are usually accepted'
      ],
      popularRoutes: ['Bangkok → Singapore', 'Bangkok → Kuala Lumpur', 'Bangkok → Ho Chi Minh']
    },
    {
      name: 'Indonesia',
      code: 'ID',
      requirements: [
        'Onward ticket required for visa-on-arrival and visa-free entry',
        'Ticket should show departure within 30-60 days',
        'Both printed and digital copies are accepted',
        'Make sure the ticket shows your name exactly as in passport'
      ],
      popularRoutes: ['Bali → Singapore', 'Bali → Kuala Lumpur', 'Bali → Bangkok']
    },
    {
      name: 'Vietnam',
      code: 'VN',
      requirements: [
        'Proof of onward travel may be requested at border',
        'Recommended to have ticket showing departure within 30 days',
        'Digital copies on phone are generally accepted',
        'Some airlines may require physical ticket for check-in'
      ],
      popularRoutes: ['Ho Chi Minh → Bangkok', 'Ho Chi Minh → Singapore', 'Hanoi → Bangkok']
    },
    {
      name: 'Malaysia',
      code: 'MY',
      requirements: [
        'Onward ticket proof may be required for certain nationalities',
        'Ticket should show departure within 90 days',
        'Both digital and printed formats accepted',
        'Commonly checked at airport immigration'
      ],
      popularRoutes: ['Kuala Lumpur → Singapore', 'Kuala Lumpur → Bangkok', 'Kuala Lumpur → Bali']
    }
  ];

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <h3 className="text-center mb-4">Country-Specific Visa Requirements</h3>
          <p className="text-center text-muted mb-4">
            Requirements vary by country. Here are guides for popular destinations:
          </p>
          
          <div className="row g-3">
            {countries.map((country, index) => (
              <div key={index} className="col-12 col-md-6">
                <div className="card h-100">
                  <div className="card-header bg-primary text-white">
                    <h5 className="mb-0">
                      <i className="bi bi-flag me-2"></i>
                      {country.name}
                    </h5>
                  </div>
                  <div className="card-body">
                    <h6 className="text-muted mb-3">Requirements:</h6>
                    <ul className="small">
                      {country.requirements.map((req, i) => (
                        <li key={i}>{req}</li>
                      ))}
                    </ul>
                    <div className="mt-3">
                      <strong className="small">Popular Routes:</strong>
                      <div className="d-flex flex-wrap gap-1 mt-2">
                        {country.popularRoutes.map((route, i) => (
                          <span key={i} className="badge bg-secondary">{route}</span>
                        ))}
                      </div>
                    </div>
                    <p className="small text-muted mt-3 mb-0">
                      <strong>Note:</strong> Always verify current requirements with the embassy or consulate before traveling.
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryGuides;

